import { TasksAPI } from "@/api/tasks";
import type {
  iCreateTaskClaimDto,
  iUpdateTaskClaimDto,
  tTaskClaim,
} from "@/types";
import websocket from "@/websocket";
import { TaskClaimsMutationHandler } from "./mutationHandler";
import { TaskMutationHandler } from "../tasks/mutationHandler";

export const TaskClaimsService = {
  async createTaskClaim(taskId: string, data: iCreateTaskClaimDto) {
    const claim: tTaskClaim = await TasksAPI.createDispute(taskId, data);
    websocket.execIfNotConnected(() => {
      TaskClaimsMutationHandler.claimCreated({ claim });
      TaskMutationHandler.taskPartiallyUpdated({
        task_id: taskId,
        updates: { claim: claim._id },
      });
    });
  },
  async updateTaskClaim(claimId: string, data: iUpdateTaskClaimDto) {
    const claim: tTaskClaim = await TasksAPI.updateDispute(claimId, data);
    websocket.execIfNotConnected(() => {
      TaskClaimsMutationHandler.claimUpdated({ claim });
    });
  },
  async removeTaskClaim(claimId: string) {
    const claim: tTaskClaim = await TasksAPI.removeDispute(claimId);
    websocket.execIfNotConnected(() => {
      TaskClaimsMutationHandler.claimRemoved({ claim });
    });
  },
};
